<template>
  <div class="grid-container">
    <div class="grid-x">
      <div class="small-12 medium-12 large-12 cell">
        <form id="wishesForm" @change="updateFilters">
          <div class="grid-x grid-margin-x">
            <!-- <div class="small-12 cell">
              <label for="type">Typ av annons</label>
              <label><input v-model="filters.houseType" type="checkbox" value="1" />Hyresrätt</label>
              <label><input v-model="filters.houseType" type="checkbox" value="2" />Bostadsrätt</label>
            </div> -->
            <div class="cell small-12">
              <h3>{{ $t('filters.your-filters') }}</h3>
            </div>
            <div class="small-12 large-4 cell">
              <FloatLabel fixed>
                <select id="maxRent" v-model.number="filters.maxRent" class="x-small">
                  <option value selected disabled>
                    {{ $t('filter.maxrent') }}
                  </option>
                  <option value="5000">
                    5 000 kr / {{ $t('ad.month') }}
                  </option>
                  <option value="6000">
                    6 000 kr / {{ $t('ad.month') }}
                  </option>
                  <option value="7000">
                    7 000 kr / {{ $t('ad.month') }}
                  </option>
                  <option value="8000">
                    8 000 kr / {{ $t('ad.month') }}
                  </option>
                  <option value="9000">
                    9 000 kr / {{ $t('ad.month') }}
                  </option>
                  <option value="10000">
                    10 000 kr / {{ $t('ad.month') }}
                  </option>
                  <option value="12000">
                    12 000 kr / {{ $t('ad.month') }}
                  </option>
                  <option value="14000">
                    14 000 kr / {{ $t('ad.month') }}
                  </option>
                  <option value="16000">
                    16 000 kr / {{ $t('ad.month') }}
                  </option>
                  <option value="18000">
                    18 000 kr / {{ $t('ad.month') }}
                  </option>
                  <option value="20000">
                    20 000 kr / {{ $t('ad.month') }}
                  </option>

                  <option value="100000">
                    {{ $t('filter.no-upper-limit') }}
                  </option>
                </select>
              </FloatLabel>
            </div>

            <div class="small-6 large-4 cell">
              <FloatLabel fixed>
                <select v-model.number="filters.minRooms" class="x-small">
                  <option value selected disabled>
                    {{ $t('filter.min-rooms') }}
                  </option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                </select>
              </FloatLabel>
            </div>

            <div class="small-6 large-4 cell">
              <FloatLabel fixed>
                <select v-model.number="filters.minSize" class="x-small">
                  <option value selected disabled>
                    {{ $t('filter.min-size') }}
                  </option>
                  <option value="0">
                    {{ $t('filter.no-lower-limit') }}
                  </option>
                  <option value="30">
                    30 {{ $t('filter.sqmt') }}
                  </option>
                  <option value="40">
                    40 {{ $t('filter.sqmt') }}
                  </option>
                  <option value="50">
                    50 {{ $t('filter.sqmt') }}
                  </option>
                  <option value="60">
                    60 {{ $t('filter.sqmt') }}
                  </option>
                  <option value="70">
                    70 {{ $t('filter.sqmt') }}
                  </option>
                  <option value="80">
                    80 {{ $t('filter.sqmt') }}
                  </option>
                  <option value="90">
                    90 {{ $t('filter.sqmt') }}
                  </option>
                  <option value="100">
                    100 {{ $t('filter.sqmt') }}
                  </option>
                  <option value="120">
                    120 {{ $t('filter.sqmt') }}
                  </option>
                  <option value="150">
                    150 {{ $t('filter.sqmt') }}
                  </option>
                </select>
              </FloatLabel>
            </div>

            <!-- <pre>{{ JSON.stringify(filters.locationIds,null,2) }}</pre> -->
            <!-- <pre>{{ JSON.stringify(selectedLocationsAndTheirChildren,null,2) }}</pre> -->
            <!-- <div class="small-12 cell">
              <FloatLabel :label="$t('filter.areas')" :dispatch="false" :fixed="true" class="locationLabel" />

              <Treeselect
                v-if="locations"
                v-model="filters.locationIds"
                :multiple="true"
                :searchable="true"
                :options="locations"
                :value-consists-of="'LEAF_PRIORITY'"
                :flatten-search-results="false"
                placeholder="Var söker du bostad?"
                :loading="true"
                search-nested
                :clear-on-select="true"
                
                @input="updateFilters" />
            </div> -->
          </div>
        </form>
      </div>

      <div class="grid-x">
        <div class="cell"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'
import FloatLabel from '@/components/FloatLabels.vue'

// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

// import UserService from '@/services/UserService.js'
import { mapState, mapGetters } from 'vuex'

export default {
  components: { Treeselect, FloatLabel },

  data() {
    return {
      msg: ''
      // filters: {},
      // locations: []
    }
  },
  computed: {
    ...mapGetters(['prospectsPhotos', 'selectedLocationsAndTheirChildren']),
    ...mapState(['filters', 'locations'])
  },
  mounted() {
    this.$store.dispatch('getLocations')
  },
  created() {
    if (!this.filters) {
      this.$store.dispatch('getFilters')
    }
    // UserService.getLocations()
    //   .then(response => {
    //     this.locations = response.data.data
    //   })
    //   .catch(error => {
    //     this.errors = error
    //   })
    // if (!this.locations) {
    //   this.$store.dispatch('getLocations')
    // }
  },
  methods: {

    onSearchChange(instance) {
      setTimeout(() => {
        let maxWidth = 0;
        this.$el.getElementsByClassName('vue-treeselect__label').forEach(v => {
          if (!v.parentNode.parentNode.classList.contains('vue-treeselect__option--hide')) {
            const width = this.getTextWidth(v.innerHTML);
            if (width > maxWidth) {
              maxWidth = width;
            }
          }
        });
        this.$el.getElementsByClassName('vue-treeselect__menu-container').forEach(v => {
          const parentWidth = v.parentNode.clientWidth;
          if (parentWidth < maxWidth + 80) {
            v.style.width = maxWidth + 80 + 'px';
          } else {
            v.style.width = '100%';
          }
          v.style.fontSize = '17px';
        });
      }, 100);
    },
    onOpenMenu(instance) {
      setTimeout(() => {
        let maxWidth = 0;
        this.$el.getElementsByClassName('vue-treeselect__label').forEach(v => {
          const width = this.getTextWidth(v.innerHTML);
          if (width > maxWidth) {
            maxWidth = width;
          }
        });
        this.$el.getElementsByClassName('vue-treeselect__menu-container').forEach(v => {
          if (v.clientWidth < maxWidth + 80) {
            v.style.width = maxWidth + 80 + 'px';
          }
        });
      }, 100);
    },
    onCloseMenu(instance) {
      this.$el.getElementsByClassName('vue-treeselect__menu-container').forEach(v => {
        v.style.width = '100%';
        v.style.fontSize = '17px';
      });
    },
    getTextWidth(val) {
      const text = document.createElement('span');
      document.body.appendChild(text);

      text.style.font = 'Nunito Sans';
      text.style.fontSize = 17 + 'px';
      text.style.height = 'auto';
      text.style.width = 'auto';
      text.style.position = 'absolute';
      text.style.whiteSpace = 'no-wrap';
      text.style.top = '0';
      text.style.lefte = '0';
      text.innerHTML = val;

      const width = Math.ceil(text.clientWidth);
      document.body.removeChild(text);
      return width;
    },

    formUpdated() {
      alert('Updated')
    },
    updateFilters() {
      // console.log('I ran updated filter in MyFilters.vue')
      this.$store.commit('SET_PROSPECTS', [])
      this.$store.commit('SET_PROSPECTS_LOADING', true)
      this.$store.dispatch('setFilters', this.filters).then(() => {
        this.$store.dispatch('updateProspects').then(() => {
          this.$store
            .dispatch('preLoadImages', this.prospectsPhotos)
            .then(() => {
              this.$store.commit('SET_PROSPECTS_LOADING', false)
            })
        })
      })
    }
  }
}
</script>

<style>

/* .vue-treeselect input[type="email"], .vue-treeselect input[type="tel"], .vue-treeselect input[type="text"], .vue-treeselect input[type="password"]{
  font-size:17px;
  border-radius: 0;
  padding: 0;
  width:100%;
  background-color: transparent;
}

.vue-treeselect__control-arrow, .vue-treeselect__option-arrow {
  color:#ff7765 ;
  fill:#ff7765;
}
.vue-treeselect__multi-value-item{
background: #64BCB2;
color:white;
}
.vue-treeselect__value-remove svg{
  color: white;
  fill:white;
}

.vue-treeselect, .vue-treeselect__multi-value-label{
  font-size:17px;
  font-weight:400;
}

.vue-treeselect__input-container input{
  font-size:17px;
  font-weight:400;
  background-color: transparent;
}

.vue-treeselect__value-remove > svg{
  width:10px;
  height:10px;
}

.vue-treeselect__control-arrow-container{
  width:28px;
}
.vue-treeselect__control-arrow{
  width:24px;
  height:24px;
}

.vue-treeselect__control{
  padding: 20px 30px;
  background-color: #f7f7f7;
border: 0;
}

.vue-treeselect__option-arrow{
  width:15px;
  height:15px;
} */
</style>
<style scoped>

.cell{
  margin-bottom: 20px;
}
.locationLabel{
  margin-bottom:10px;
}

input.vue-treeselect__input{
  /* width:100%; */
  /* font-size: 24px; */
  /* padding:unset;
  background-color: unset;
  border-radius: unset;
  height: unset; */
}


</style>
